module.exports = __webpack_public_path__ + "img/baojia.5aaec400.png";